import { useLocation, useParams } from 'react-router-dom'
import Card from '@mui/material/Card'
import MenuItem from '@mui/material/MenuItem'
import Select from '@mui/material/Select'
import MDBox from 'components/MDBox'
import MDTypography from 'components/MDTypography'
import MDButton from 'components/MDButton'
import { useEffect, useState } from 'react'
import axios from 'axios'

function GoHighLevel() {
  const { search } = useLocation()
  const type = new URLSearchParams(search).get('type')
  const { companyId, app_id, locationId } = useParams()

  const [error, setError] = useState('')
  const [success, setSuccess] = useState('')
  const [tenantIds, setTenantIds] = useState([])
  const [selectedTenantId, setSelectedTenantId] = useState('')
  const [isConnected, setIsConnected] = useState(false)
  const [showTenantDropdown, setShowTenantDropdown] = useState(false)

  const scopes = [
    'openid',
    'profile',
    'email',
    'offline_access',
    'accounting.transactions',
    'accounting.reports.read',
    'accounting.reports.tenninetynine.read',
    'accounting.journals.read',
    'accounting.settings',
    'accounting.contacts',
    'accounting.attachments',
    'accounting.budgets.read',
  ].join(' ')

  const auth_url = `https://login.xero.com/identity/connect/authorize?
    response_type=code&
    client_id=B54310499593449880AC5BD18D52A694&
    redirect_uri=${encodeURIComponent('https://app.alltheapps.io/integrations/xero')}&
    scope=${encodeURIComponent(scopes)}&
    state=${encodeURIComponent(`${locationId},${companyId},${app_id},${type}`)}`.replace(/\s+/g, '')

  const handleConnect = (e) => {
    e.preventDefault()
    window.open(auth_url, '_blank')
    setIsConnected(true)
  }

  const fetchTenantIds = async () => {
    try {
      const response = await axios.post(
        'https://webhook.alltheapps.io/v1/xero/tenantIds',
        {
          app_id: app_id,
          locationId: locationId,
        },
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      )

      if (response?.data?.data) {
        setTenantIds(response.data.data)
        setShowTenantDropdown(true)
        setSuccess('App successfully integrated. Please choose a tenant.')
        setError('')
      }
    } catch (error) {
      console.error(error)
      setError('Failed to fetch tenant IDs. Please try again later.')
      setSuccess('')
    }
  }

  const updateTenantId = async () => {
    if (!selectedTenantId) return
    try {
      const res = await axios.post('https://webhook.alltheapps.io/v1/xero/update-tenant', {
        app_id,
        locationId,
        tenantId: selectedTenantId,
      })
      if (res.data.success) {
        setSuccess('Tenant ID successfully updated!')
        setError('')
        setTimeout(() => window.close(), 2000)
      }
    } catch (err) {
      console.error(err)
      setError('Error updating tenant ID')
      setSuccess('')
    }
  }

  // Check initial connection status (you might need to implement this API)
  useEffect(() => {
    const checkConnectionStatus = async () => {
      try {
        const response = await axios.get(
          `https://webhook.alltheapps.io/v1/xero/status?app_id=${app_id}&locationId=${locationId}`
        )
        setIsConnected(response.data.connected)
      } catch (error) {
        console.error('Error checking connection status:', error)
      }
    }
    checkConnectionStatus()
  }, [app_id, locationId])

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        backgroundSize: 'cover',
      }}
    >
      <Card
        sx={{
          width: '35%',
          textAlign: 'center',
          padding: '2rem',
          borderRadius: '29px',
          backgroundColor: 'rgba(255, 255, 255, 0.9)',
        }}
      >
        <MDTypography variant="h4" gutterBottom style={{ color: 'black' }}>
          Connect with Xero
        </MDTypography>

        {!isConnected ? (
          <MDBox component="form" onSubmit={handleConnect} sx={{ mt: 5 }}>
            <MDButton
              type="submit"
              variant="contained"
              color="info"
              fullWidth
              sx={{ mt: 2 }}
              style={{ fontSize: '0.9rem', textTransform: 'capitalize', padding: '0 5rem' }}
            >
              Connect
            </MDButton>
          </MDBox>
        ) : (
          !showTenantDropdown && (
            <MDButton
              variant="outlined"
              color="secondary"
              fullWidth
              sx={{ mt: 2 }}
              onClick={fetchTenantIds}
            >
              Fetch Tenant IDs
            </MDButton>
          )
        )}

        {showTenantDropdown && (
          <>
            <Select
              fullWidth
              value={selectedTenantId}
              onChange={(e) => setSelectedTenantId(e.target.value)}
              sx={{ mt: 3, backgroundColor: '#fff' }}
            >
              {tenantIds.map((tenant) => (
                <MenuItem key={tenant.tenantId} value={tenant.tenantId}>
                  {tenant.tenantId}
                </MenuItem>
              ))}
            </Select>

            <MDButton
              variant="contained"
              color="success"
              sx={{ mt: 2 }}
              fullWidth
              onClick={updateTenantId}
              disabled={!selectedTenantId}
            >
              Save Tenant ID
            </MDButton>
          </>
        )}

        {success && (
          <MDTypography variant="body2" style={{ color: 'green' }} mt={2}>
            {success}
          </MDTypography>
        )}

        {error && (
          <MDTypography variant="body2" color="error" mt={2}>
            {error}
          </MDTypography>
        )}
      </Card>
    </div>
  )
}

export default GoHighLevel
